export const SET_STATUS = 'SET_STATUS';
export const SET_WORKER = 'SET_WORKER';

export const SET_BOOKING_DATE = 'SET_BOOKING_DATE';
export const SET_BOOKING_AIRPORT = 'SET_BOOKING_AIRPORT';
export const SHOW_BOOKING_SIDEBAR = 'SHOW_BOOKING_SIDEBAR';

export const SET_BASIC_REGISTER_DATA = 'SET_BASIC_REGISTER_DATA';
export const UPDATE_REGISTER_FIELDS = 'UPDATE_REGISTER_FIELDS';
export const SET_USER_LOGGED = 'SET_USER_LOGGED';
export const SET_USER_LOGOUT = 'SET_USER_LOGOUT';

export const SET_CHILDREN_NUMBER = 'SET_CHILDREN_NUMBER';
export const SET_ADULTS_NUMBER = 'SET_ADULTS_NUMBER';
export const SET_KIDS_SAFETY_NUMBER = 'SET_KIDS_SAFETY_NUMBER';

export const RESET_ADDRESSES = 'RESET_ADDRESSES';
export const RESET_FLIGHTS = 'RESET_FLIGHTS';
export const SET_DEPARTURE_FLIGHT = 'SET_DEPARTURE_FLIGHT';
export const SET_RETURN_FLIGHT = 'SET_RETURN_FLIGHT';
export const SET_RETURN_ADDRESS_PHRASE = 'SET_RETURN_ADDRESS_PHRASE';
export const SET_RETURN_ADDRESS_OBJECT = 'SET_RETURN_ADDRESS_OBJECT';
export const SET_DEPARTURE_ADDRESS_PHRASE = 'SET_DEPARTURE_ADDRESS_PHRASE';
export const SET_DEPARTURE_ADDRESS_OBJECT = 'SET_DEPARTURE_ADDRESS_OBJECT';
export const SET_DIFFERENT_RETURN_ADDRESS = 'SET_DIFFERENT_RETURN_ADDRESS';
export const SET_DEPARTURE_ADDRESS_POSTCODE_ERROR_LAT_LNG = 'SET_DEPARTURE_ADDRESS_POSTCODE_ERROR_LAT_LNG';
export const SET_RETURN_ADDRESS_POSTCODE_ERROR_LAT_LNG = 'SET_RETURN_ADDRESS_POSTCODE_ERROR_LAT_LNG';
export const SET_BOOKING_PRICE = 'SET_BOOKING_PRICE';
export const SET_BOOKING_USER_DATA = 'SET_BOOKING_USER_DATA';
export const RESET_BOOKING = 'RESET_BOOKING';
export const SET_BOOKING_CARD_ID = 'SET_BOOKING_CARD_ID';
export const SET_INVOICE_FIELD_VALUE = 'SET_INVOICE_FIELD_VALUE';
export const TOGGLE_BOOKING_SEND_INVOICE = 'TOGGLE_BOOKING_SEND_INVOICE';
export const SHOW_SPLASH_SCREEN = 'SHOW_SPLASH_SCREEN';
export const HIDE_SPLASH_SCREEN = 'HIDE_SPLASH_SCREEN';
export const RESET_REGISTER_FIELDS = 'RESET_REGISTER_FIELDS';
export const TOGGLE_CREATE_ACCOUNT_IN_BOOKING = 'TOGGLE_CREATE_ACCOUNT_IN_BOOKING';
export const SET_USER_DATA_ERRORS = 'SET_USER_DATA_ERRORS';
export const START_LOADING_DATA_ON_MAP = 'START_LOADING_DATA_ON_MAP';
export const STOP_LOADING_DATA_ON_MAP = 'STOP_LOADING_DATA_ON_MAP';
export const RESET_REGISTER_ERRORS = 'RESET_REGISTER_ERRORS';
export const REFRESH_CUSTOMER_ADDRESSES_LIST = 'REFRESH_CUSTOMER_ADDRESSES_LIST';
export const SET_CUSTOMER_ADDRESSES = 'SET_CUSTOMER_ADDRESSES';
export const UPDATE_CUSTOMER_PHONE = 'UPDATE_CUSTOMER_PHONE';
export const UPDATE_CUSTOMER_INVOICE_DATA = 'UPDATE_CUSTOMER_INVOICE_DATA';
export const SET_RESERVATION_TO_EDIT = 'SET_RESERVATION_TO_EDIT';
export const SET_KIDS_SAFETY_IN_RESERVATION = 'SET_KIDS_SAFETY_IN_RESERVATION';
export const SET_CHILDREN_NUMBER_IN_RESERVATION_EDIT = 'SET_CHILDREN_NUMBER_IN_RESERVATION_EDIT';
export const SET_ADULTS_NUMBER_IN_RESERVATION_EDIT = 'SET_ADULTS_NUMBER_IN_RESERVATION_EDIT';
export const SET_STUDENTS_NUMBER_IN_RESERVATION_EDIT = 'SET_STUDENTS_NUMBER_IN_RESERVATION_EDIT';
export const SET_SERVER_RESPONDED_TO_AJAX = 'SET_SERVER_RESPONDED_TO_AJAX';
export const SET_NEW_PRICE_RESERVATION_EDIT = 'SET_NEW_PRICE_RESERVATION_EDIT';
export const SET_ADDRESS_IN_RESERVATION_EDIT = 'SET_ADDRESS_IN_RESERVATION_EDIT';
export const SET_PRICE_LIST = 'SET_PRICE_LIST';
export const SET_CARD_ID_IN_RESERVATION_EDIT = 'SET_CARD_ID_IN_RESERVATION_EDIT';
export const RESET_RESERVATION_UPDATE_DATA = 'RESET_RESERVATION_UPDATE_DATA';
export const RESET_KIDS_SAFETY_IN_RESERVATION_EDIT = 'RESET_KIDS_SAFETY_IN_RESERVATION_EDIT';
export const RESET_KIDS_SAFETY_IN_BOOKING = 'RESET_KIDS_SAFETY_IN_BOOKING';
export const CREATE_NOTIFICATION = 'CREATE_NOTIFICATION';
export const SET_DASHBOARD_RESERVATIONS = 'SET_DASHBOARD_RESERVATIONS';
export const CANCEL_RESERVATION = 'CANCEL_RESERVATION';
export const SET_BUS_STOP_LIST = 'SET_BUS_STOP_LIST';
export const START_FROM_BOOKING = 'START_FROM_BOOKING';
export const SET_RESERVATION_TO_REVIEW = 'SET_RESERVATION_TO_REVIEW';
export const HIDE_REVIEW_FORM_IN_RESERVATION = 'HIDE_REVIEW_FORM_IN_RESERVATION';
export const OVERRIDE_RESERVATION = 'OVERRIDE_RESERVATION';
export const SET_MY_TRIPS = 'SET_MY_TRIPS';
export const SET_FILTER_DATE_IN_TRIPS = 'SET_FILTER_DATE_IN_TRIPS';
export const SET_STUDENTS_NUMBER = 'SET_STUDENTS_NUMBER';
export const SET_USER_NAME_OVERRIDE = 'SET_USER_NAME_OVERRIDE';
export const SET_USER_PHONE_OVERRIDE = 'SET_USER_PHONE_OVERRIDE';
